import dynamic from 'next/dynamic';
import { HeaderLoader } from '@sparknz/journeys-common';

const DynamicHeader = dynamic(() => import('./Header'), {
  ssr: false,
  loading: HeaderLoader,
});

export default DynamicHeader;
